import { Layout } from 'react-admin';
import CustomAppBar from './appbar/AppBar';
import { CustomMenu } from './menu/Menu';

const CustomLayout = (props) => (
  <Layout
    {...props}
    appBar={CustomAppBar}
    menu={CustomMenu}
  />
);

export default CustomLayout;
